import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from '@/lib/store/api/baseQuery'
import { chosenPharmacyReducer } from '@/lib/store/chosenPharmacySlice'

import '@/lib/store/api/assistantFeedbackApi'
import '@/lib/store/api/careJourneyApi'
import '@/lib/store/api/carePlanApi'
import '@/lib/store/api/carePlanConditionGroupsApi'
import '@/lib/store/api/patientOrdersApi'
import '@/lib/store/api/fileUploadApi'
import '@/lib/store/api/pharmacyOrderApi'
import '@/lib/store/api/pharmacyPricingApi'
import '@/lib/store/api/preferredPharmacyApi'
import '@/lib/store/api/paymentServiceApi'
import '@/lib/store/api/prescriptionApi'
import '@/lib/store/api/prescriptionRenewalApi'
import '@/lib/store/api/healthHistoryApi'
import '@/lib/store/api/emergencyContactsApi'
import '@/lib/store/api/personalInformationApi'
import '@/lib/store/api/referral/ordersApi'
import '@/lib/store/api/referral/preferenceApi'
import '@/lib/store/api/referral/providersApi'
import '@/lib/store/api/referral/paymentApi'
import '@/lib/store/api/partnerConsentsApi'
import '@/lib/store/api/emailValidationApi'
import '@/lib/store/api/signupApi'
import '@/lib/store/api/updatesApi'
import '@/lib/store/api/messageCenterApi'
import '@/lib/store/api/myCareApi'
import '@/lib/store/api/nextStepCardsApi'
import '@/lib/store/api/questionnaireResponseApi'
import '@/lib/store/api/questionsApi'
import '@/lib/store/api/dashboardIntroApi'
import '@/lib/store/api/skuApi'
import '@/lib/store/api/providerApi'
import '@/lib/store/api/directoryPharmacyApi'
import '@/lib/store/api/productDetailPageApi'
import '@/lib/store/api/trackedLinksApi'
import '@/lib/store/api/tenantIntegrationsApi'
import '@/lib/store/api/userApi'
import '@/lib/store/api/urgentCareApi'
import '@/lib/store/api/urgentCareLocationsApi'
import '@/lib/store/api/visitStatusUpdateApi'
import '@/lib/store/api/visitCheckInStepsApi'

export const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        chosenPharmacy: chosenPharmacyReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
